import './sass/main.scss';
import './carousel.js';
import './mobile-menu.js';
import './scripts/scroll.js';
import './scripts/modal-maps';
new WOW().init();
